import { render, staticRenderFns } from "./ReopenButton.vue?vue&type=template&id=fa4c9460&"
import script from "./ReopenButton.vue?vue&type=script&lang=js&"
export * from "./ReopenButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports